/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconGavel: {
  name: 'gavel';
  data: string;
} = {
  name: 'gavel',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 612 612"><path d="M225.771 184.208h1.195l1.195 1.195 1.195-1.195h11.953l1.195 1.195 1.195-1.195h1.195v9.563h-1.195l-1.195-1.195-1.195 1.195h-3.586v27.492c0 1.195-1.195 1.195-1.195 1.195h-2.391s-1.195 0-1.195-1.195v-27.492h-3.586l-1.195-1.195-1.195 1.195h-1.195v-9.563z" transform="matrix(15 0 0 15 -3224 -2744)"/></svg>`,
};
